export default __webpack_public_path__ + "static/media/10.bf88e275.jpg";